import * as Styled from './Separator.styles';
import { ISeparatorProps } from './Separator.types';

const Separator = ({ separator }: ISeparatorProps) => (
  <>
    {typeof separator === 'string' ? (
      <Styled.TextSeparator aria-hidden="true">{separator}</Styled.TextSeparator>
    ) : (
      separator
    )}
  </>
);

export default Separator;
